import React,{useState,useEffect,useContext,createContext} from 'react'
import {Navigate,useNavigate,useLocation,Link} from 'react-router-dom'
import '../../css/style.css'
import home from '../../css/images/home.png'
import burn from '../../css/images/burn.png'
import cube3 from '../../css/images/cube3.png'
import chat from '../../css/images/chat.png'
import coach from '../../css/images/coach.png'
import bell from '../../css/images/bell.png'
import menu from '../../css/images/menu.png'
import {UserContext} from '../../context/UserContext'

export default function Footer3() {
  const navigate = useNavigate()
  const {pathname} = useLocation()
  const {socket,setSocket}=useContext(UserContext)
  const {messageNotifications,setMessageNotifications}=useContext(UserContext)
  const {generalNotifications,setGeneralNotifications}=useContext(UserContext)

  const activeStyle = {filter:'invert(56%) sepia(87%) saturate(4257%) hue-rotate(344deg) brightness(101%) contrast(95%)'}
  const isActive = (route) => pathname === route ? activeStyle : {}

  return (
    <footer>
    <div className="footer-wrap">
      <div className="footer-div">
        <div className="footer-item" style={isActive('/home')} onClick={()=>navigate('/home')}>
          <button style={{backgroundImage:`url(${home})`}}></button>
          <div className="footer-item-title">Home</div>
        </div>
        <div className="footer-item" style={isActive('/walloffame')} onClick={()=>navigate('/walloffame')}>
          <button style={{backgroundImage:`url(${burn})`}}></button>
          <div className="footer-item-title" style={{fontSize:'8px'}}>Wall of Flames</div>
        </div>
        <div className="footer-item" style={isActive('/challenges')} onClick={()=>navigate('/challenges')}>
          <button style={{backgroundImage:`url(${cube3})`}}></button>
          <div className="footer-item-title">Challenges</div>
        </div>
        <div className="footer-item" style={isActive('/coach')} onClick={()=>navigate('/coach')}>
          <button style={{backgroundImage:`url(${coach})`}}></button>
          <div className="footer-item-title">Training</div>
        </div>
        {/* <div className="footer-item" style={isActive('/chat')} onClick={()=>navigate('/chat')}>
          <button style={{backgroundImage:`url(${chat})`}}></button>
          {messageNotifications>0 &&
            <div className="footer-bubble">{messageNotifications}</div>
          }
          <div className="footer-item-title">Chat</div>
        </div> */}
        <div className="footer-item" style={isActive('/notifications')} onClick={()=>navigate('/notifications')}>
          <button style={{backgroundImage:`url(${bell})`}}></button>
          {generalNotifications+messageNotifications>0 &&
            <div className="footer-bubble">{generalNotifications+messageNotifications}</div>
          }
          <div className="footer-item-title">Notifications</div>
        </div>
        <div className="footer-item" style={isActive('/menu')} onClick={()=>navigate('/menu')}>
          <button style={{backgroundImage:`url(${menu})`}}></button>
          <div className="footer-item-title">Menu</div>
        </div>
      </div>
    </div>
  </footer>
  )
}